import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const fmt = (n) => (n >= 1000 ? `${(n / 1000).toFixed(n >= 10000 ? 0 : 1)}k` : String(n));

export default function ProofStats() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/public/stats").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return null;
  const scaled = s.properties >= 100;
  const items = scaled
    ? [[s.rules, "statutory rules tracked", "across England, Wales & Scotland"], [s.certificates, "certificates filed", "uploaded, emailed-in or auto-booked"], [s.reminders, "reminders sent", "before anything lapsed"], [s.properties, "properties protected", `by ${fmt(s.landlords)} landlords & agents`]]
    : [[s.rules, "statutory rules tracked", "every one linked to official guidance"], [s.nations, "nation rule packs", "England, Wales & Scotland"], ["14", "day free trial", "no card required"], ["1", "click Evidence Pack", "court-ready, hash-stamped"]];
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-testid="proof-stats">
      {items.map(([v, l, sub], i) => (
        <div key={l} className="rounded-2xl border border-border bg-card p-5 animate-fade-up" style={{ animationDelay: `${i * 80}ms` }}>
          <p className="font-heading text-3xl sm:text-4xl font-extrabold text-navy">{typeof v === "number" ? fmt(v) : v}</p>
          <p className="text-sm font-medium mt-1">{l}</p>
          <p className="text-xs text-muted-foreground">{sub}</p>
        </div>))}
    </div>
  );
}
